<div class="d-flex flex-column">
  <div *ngIf="viewAs" class="alert alert-warning mb-0 rounded-0 d-flex align-items-center justify-content-between" style="position: relative; z-index: 11" role="status">
    <span>Viewing as <strong>{{viewAs.target.username}}</strong> — read-only accounting reports. Changes are blocked. Session logged; expires {{viewAs.expires_at | date:'shortTime'}}.</span>
    <button type="button" class="btn btn-dark btn-sm ms-2 flex-shrink-0 text-nowrap" (click)="exitViewAs()">Exit user view</button>
  </div>
  <header class="header-bar">
      <div class="header-left">
        <button class="menu-toggle" (click)="drawer.toggle()" *ngIf="mobileQuery.matches">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg>
        </button>
        <img src="/assets/winwin-horizontal.png" class="header-logo" alt="Logo" />
        <div class="header-title" *ngIf="!mobileQuery.matches">
          <span class="title-text">Admin Panel</span>
          <span class="title-divider" *ngIf="company_name">|</span>
          <span class="company-name" *ngIf="company_name">{{company_name}}</span>
          <span class="company-slogan" *ngIf="company_slogan">{{company_slogan}}</span>
        </div>
      </div>

      <div class="header-actions">
        <a *ngIf="!shareholder" class="header-action wallet-badge" [routerLink]="['/lo', company_uuid, 'ww-wallet']" title="Wallet Balance">
          <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18" fill="currentColor"><path d="M444-200h70v-50q50-9 86-39t36-89q0-42-24-77t-96-61q-60-20-83-35t-23-41q0-26 18.5-41t53.5-15q32 0 50 15.5t26 38.5l64-26q-11-35-40.5-61T516-710v-50h-70v50q-50 11-78 44t-28 74q0 47 27.5 76t86.5 50q63 23 87.5 41t24.5 47q0 33-23.5 48.5T486-314q-33 0-58.5-20.5T390-396l-66 26q14 48 43.5 77.5T444-252v52Zm36 120q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
          <span class="wallet-amount">{{wallet_balance ?? 0}}</span>
        </a>
        <a *ngIf="!shareholder" class="header-action wallet-badge ai-badge" title="AI Credit Balance">
          <span style="font-weight:700;font-size:12px;letter-spacing:.5px">AI</span>
          <span class="wallet-amount">{{ai_balance ?? 0}}</span>
        </a>
        <div class="color-picker-wrap">
          <button class="header-action" (click)="toggleLangPicker()" title="Language">
            <span style="font-size:16px">{{ activeLang === 'en' ? '🇬🇧' : activeLang === 'ms' ? '🇲🇾' : '🇨🇳' }}</span>
          </button>
          <div class="color-dropdown lang-dropdown" *ngIf="showLangPicker">
            <div class="color-dropdown-title">Language</div>
            <button *ngFor="let lang of languages"
              class="lang-option"
              [class.active]="activeLang === lang.code"
              (click)="applyLang(lang)">
              <span class="lang-flag">{{lang.flag}}</span>
              <span class="lang-label">{{lang.label}}</span>
              <svg *ngIf="activeLang === lang.code" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="rgba(var(--color),1)" viewBox="0 0 16 16">
                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
              </svg>
            </button>
          </div>
          <div class="color-backdrop" *ngIf="showLangPicker" (click)="showLangPicker = false"></div>
        </div>
        <div class="color-picker-wrap">
          <button class="header-action" (click)="toggleColorPicker()" title="Change Theme">
            <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18" fill="currentColor"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 32.5-156t88-127Q256-817 330-848.5T488-880q80 0 151 27.5t124.5 76q53.5 48.5 85 115T880-518q0 115-70 176.5T640-280h-74q-9 0-12.5 5t-3.5 11q0 12 15 34.5t15 51.5q0 50-27.5 74T480-80Zm0-400Zm-220 40q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm120-160q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm200 0q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm120 160q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17ZM480-160q9 0 14.5-5t5.5-13q0-14-15-33t-15-57q0-42 29-67t71-25h70q66 0 113-38.5T800-518q0-121-92.5-201.5T488-800q-136 0-232 93t-96 227q0 133 93.5 226.5T480-160Z"/></svg>
          </button>
          <div class="color-dropdown" *ngIf="showColorPicker">
            <div class="color-dropdown-title">Theme Color</div>
            <div class="color-grid">
              <button *ngFor="let t of themeColors"
                class="color-swatch"
                [class.active]="activeColor === t.color"
                [style.background]="'rgb(' + t.color + ')'"
                [title]="t.name"
                (click)="applyColor(t)">
                <svg *ngIf="activeColor === t.color" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" [style.color]="t.text">
                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="color-backdrop" *ngIf="showColorPicker" (click)="showColorPicker = false"></div>
        </div>
        <button class="header-action logout-action" (click)="logout()" title="Logout">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
            <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
          </svg>
        </button>
      </div>
  </header>

  <div class="marquee-bar" *ngIf="marqueeText">
    <div class="marquee-track">
      <span class="marquee-content" [innerHTML]="safeMarqueeHtml"></span>
    </div>
  </div>

  <mat-sidenav-container class="menu-container" [hasBackdrop]="mobileQuery.matches">
    <mat-sidenav #drawer [mode]="mobileQuery.matches ? 'over' : 'side'" [opened]="!mobileQuery.matches" [fixedInViewport]="mobileQuery.matches" [fixedTopGap]="mobileQuery.matches ? 56 : 0" >
      <app-sidebar #mobile [setCompanies]="companies" [setSelectedCompany]="company_uuid"></app-sidebar>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="container-fluid">
          <div class="w-100 p-md-3">
            <router-outlet></router-outlet>
          </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <app-ai-chatbot *ngIf="!shareholder"></app-ai-chatbot>

  <!-- ── Live Chat floating button ── -->
  <button class="chat-fab" (click)="openChatPanel(chatPanel)" title="Live Chat" *ngIf="!shareholder && !chatOpen">
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 16 16">
      <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
      <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125"/>
    </svg>
    <span class="chat-fab-badge" *ngIf="chatUnread > 0">{{ chatUnread > 99 ? '99+' : chatUnread }}</span>
  </button>
</div>

<!-- ── Live Chat offcanvas (slides in from right) ── -->
<ng-template #chatPanel let-offcanvas>
  <div class="chat-offcanvas-shell">
    <div class="chat-offcanvas-header">
      <span class="chat-offcanvas-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
          <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
          <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125"/>
        </svg>
        Live Chat
      </span>
      <div class="chat-offcanvas-actions">
        <a class="chat-offcanvas-btn" [routerLink]="['/lo', company_uuid, 'web-chat-settings']" (click)="offcanvas.dismiss()" title="Web Chat Settings (Web WhatsApp / Web Telegram)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
            <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
          </svg>
        </a>
        <a class="chat-offcanvas-btn" [routerLink]="['/lo', company_uuid, 'chat']" (click)="offcanvas.dismiss()" title="Open full page">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"/>
          </svg>
        </a>
        <button class="chat-offcanvas-btn" (click)="offcanvas.dismiss()" title="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="chat-offcanvas-body">
      <app-chat [embedded]="true"></app-chat>
    </div>
  </div>
</ng-template>


<!-- Pending Deposit/Withdraw Floating Modal -->
<div class="pending-modal" *ngIf="showPendingModal">
  <button class="pending-modal-close" (click)="showPendingModal = false" title="Dismiss">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
    </svg>
  </button>
  <div class="pending-modal-title">Pending Actions</div>
  <a *ngIf="pendingDepositCount > 0" [routerLink]="['/lo', company_uuid, 'deposit']" class="pending-modal-item">
    <span class="pending-modal-badge">{{pendingDepositCount}}</span>
    <span>Unprocessed Deposit</span>
  </a>
  <a *ngIf="pendingWithdrawCount > 0" [routerLink]="['/lo', company_uuid, 'withdraw']" class="pending-modal-item">
    <span class="pending-modal-badge">{{pendingWithdrawCount}}</span>
    <span>Unprocessed Withdraw</span>
  </a>
</div>

<ng-template #customNotification let-notificationData="notification">
  <div class="d-flex flex-column justify-content-between">
    <div class="d-flex flex-row justify-content-between">
      <span>You have new message.</span>
      <a [routerLink]="['/lo', company_uuid, 'chat', notificationData.id ]" class="text-decoration-none d-flex flex-column"> 
        <span>View</span>
      </a>
    </div>
    <span class="text-muted small fst-italic d-block w-100 text-truncate">{{notificationData.message}}</span>
  </div>
</ng-template>

<ng-template #customNotificationDeposit let-notificationData="notification">
  <a [routerLink]="['/lo', company_uuid, 'deposit']" class="text-decoration-none d-flex flex-column ">
      <span>You have new deposit pending approval.</span>
  </a>
</ng-template>

<ng-template #customNotificationWithdraw let-notificationData="notification">
  <a [routerLink]="['/lo', company_uuid, 'withdraw']" class="text-decoration-none d-flex flex-column ">
      <span>You have new withdraw pending approval.</span>
  </a>
</ng-template>
